import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=09248c77&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTooltip} from 'quasar'
component.options.components = Object.assign({QTooltip}, component.options.components || {})
